/**
 * api接口
 *           Author by wjl. on 2020.03.28
 *
 * 修改了以前的对象的方式，以前各方法作为对象属性，问题在打包（build）后，会把整个对象打进去。
 * 现改用es6的模块方式，前端引用方法：
 *      import * as api from '../api.js';
 *      api.signin();
 * 打包时webpack的tree-shaking会只处理被引用的方法
 */

import router from '../router';
import {Message} from 'element-ui';
import Axios from 'axios';
import qs from 'qs';

/*
 * 封装Axios
 * @param string url 请求的URL地址
 * @param Object params post发送的数据/get的参数
 * @param Object opts 请求的设置项
 *      loading:设置是否现实loading菊花
 *      method：设置get|post|put|delete提交，默认是get
 *
 * @return Promise 返回Promise对象
 *
 */
let request = (url, params = {}, opts = {}) => {
  // console.log(`api.request：`, url, params, opts);
  // 组装请求的param
  let headers = {}
  if (localStorage.getItem('Authorization')) {
    headers = {
      [process.env.AUTHORIZATION]: 'bearer ' + localStorage.getItem('Authorization'),
      'X-Frame-Options': 'DENY',   // 防止项目被嵌套
    }
    if (opts.headers) {
      headers = {...headers, ...opts.headers}
    }
  }
  let param = {
    // window.g.BASE_API 本地改配置端口
    url: process.env.NODE_ENV === 'native' && window.g && window.g.BASE_API ? window.g.BASE_API + url : process.env.BASE_API + url,
    method: opts.method || 'get',
    // 用户认证token
    headers: headers,
    params: {}
  };
  //  post||put请求
  if (param.method.toLowerCase() === 'post' && opts.contentType) {
    param.headers['Content-Type'] = opts.contentType;
    if(opts.qsParams){
      param.data = params;  // 直接编译好的参数
    }else{
      param.data = qs.stringify(params);
    }
  } else if ((param.method.toLowerCase() === 'post' && !opts.contentType) || param.method.toLowerCase() === 'put') {
    param.data = params
  } else {
    // get||delete请求
    param.params = Object.assign(param.params, params);
  }
  // 4. 发起请求
  return Axios.request(param)
    .then(res => {
      if (res && res.data && res.status === 200) {
        // 正常返回
        return Promise.resolve(res.data);
      }
    })
    .catch(e => {
      return Promise.reject(e)
    });
};

Axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么

  if (config.url.includes('/api-oauth/v1/oauth/v2/oauth/token')) {

    return getTime().then(res => {

      const BeijingTime = new Date(res).getTime();
      const SystemTime = new Date().getTime();
      const mismatch = (BeijingTime - SystemTime) / 1000 / 60;
      const ErrorTime = 10; // 10分钟  // 当地时间和北京时间间隔不能超过的时间

      console.log('---北京时间--',  res, mismatch)

      if (mismatch >= ErrorTime) {
        alert('您的时钟慢了，请校准时间。');
        return
      } else {
        return config;
      }

    })
  } else {
    return config;
  }

}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
Axios.interceptors.response.use(response => {
  let Authorization = localStorage.getItem('Authorization');
  if (Authorization) {
    response.headers.Authorization = 'bearer ' + Authorization;
  }
  if (response.data.code == 6) {
    router.push({
      path: '/no-permission',
      query: {
        type: 6
      }
    })
  }
  return response;
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        Message.error('请求错误(400)');
        break;
      case 401:
        localStorage.clear();
        router.push({
          path: '/'
        })
        // Message.error({ showClose: true, message: '登录已过期，请重新登录' })
        break;
      case 403:
        Message.error({showClose: true, message: '拒绝访问(403)'});
        break;
      case 404:
        Message.error({showClose: true, message: '请求出错(404)'});
        break;
      case 408:
        Message.error({showClose: true, message: '请求超时(408)'});
        break;
      case 500:
        Message.error({showClose: true, message: '服务器错误(500)'});
        break;
      case 501:
        Message.error({showClose: true, message: '服务未实现(501)'});
        break;
      case 502:
        Message.error({showClose: true, message: '网络错误(502)'});
        break;
      case 503:
        Message.error({showClose: true, message: '服务不可用(503)'});
        break;
      case 504:
        Message.error({showClose: true, message: '网络超时(504)'});
        break;
      case 505:
        Message.error({showClose: true, message: 'HTTP版本不受支持(505)'});
        break;
      default:
        Message.error({showClose: true, message: `连接出错(${error.response.status})!`});
    }
  }
  return Promise.reject(error)
  //return Promise.resolve(error);//请求错误时，不会直接结束，将会继续传到then里面,无论请求成功还是失败，在成功的回调中都能收到通知
});

/**
 * 获取服务器时间
 */
export function getTime() {
  return new Promise((success) => {
    var xhr = null;
    // console.log(window.XMLHttpRequest)
    if (window.XMLHttpRequest) {
      xhr = new window.XMLHttpRequest();
    } else { // ie
      xhr = new window.ActiveObject("Microsoft")
    }
    // 通过get的方式请求当前文件
    xhr.open("get", `/?time=${new Date().getTime()}`);
    xhr.send(null);
    // 监听请求状态变化
    xhr.onreadystatechange = function () {
      var time = null,
        curDate = null;
      if (xhr.readyState === 2) {
        // 获取响应头里的时间戳
        time = xhr.getResponseHeader("Date");
        curDate = new Date(time);
        // console.log(curDate)
        success(curDate)
      }
    }
  })

}

export default request



// WEBPACK FOOTER //
// ./src/api/api.js